// resources/js/calculator/analytics.js
// No-op-safe dataLayer push stub (CLAUDE.md §8, ANL-01 — real GTM wiring is Phase 8).
// Because window.dataLayer is lazily created, pushes are harmless with no GTM container
// present: they queue in an array that GTM (Phase 8) later drains (Google's documented pattern).
//
// Events fired (from state.js):
//   calc_started         — step-1 enter (init)
//   calc_step_completed  — { step_number } on each forward
//   calc_result_viewed   — { eligible_count, displayed_count, result_type } on handoff
//   Phase 6 (conversion path):
//   lead_phone_submitted — { consent_call, consent_sms }  — MAIN CONVERSION; only when res.track === true
//   form_error           — { field_name, error_type }     — client validation failure on submit
//   webhook_success      — /lead 200 with res.delivered === true
//   webhook_error        — /lead 200 with res.delivered === false

/**
 * Push an event onto the dataLayer. Safe when GTM is absent, and safe in non-browser
 * (node) environments where `window` is undefined.
 *
 * @param {string} event   the dataLayer event name
 * @param {Object} params  additional event parameters
 */
export function track(event, params = {}) {
  if (typeof window === 'undefined') return // node/import guard — no-op off-browser
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({ event, ...params })
}
